import { useQuery } from '@tanstack/react-query'
import { X, Mail, Building2, Briefcase, Clock, MessageSquare, Loader2, Shield } from 'lucide-react'
import { chatService } from '../../services/chatService'
import { avatarGradient, initials } from '../crm/pipeline/tokens'
import { formatDateTime } from '../../utils/formatters'

// Kişi profili — sağ panel (mention/avatar tıklanınca)
export default function UserProfilePanel({ company, userId, onClose, onStartDm,
  className = 'w-full lg:w-[380px] shrink-0 border-l border-gray-100' }) {
  const { data, isLoading } = useQuery({
    queryKey: ['chat-profile', userId],
    queryFn: () => chatService.userProfile(company, userId),
    enabled: !!userId,
  })
  const u = data?.data

  return (
    <div className={`${className} bg-gray-50/40 flex flex-col overflow-hidden`}>
      <div className="px-4 py-2.5 border-b border-gray-100 flex items-center gap-2 bg-white shrink-0">
        <span className="text-sm font-semibold text-gray-800 flex-1">Kişi</span>
        <button onClick={onClose} className="p-1 text-gray-400 hover:text-gray-700"><X size={16} /></button>
      </div>
      <div className="flex-1 overflow-y-auto p-4">
        {isLoading || !u ? (
          <div className="py-10 text-center text-gray-400"><Loader2 size={18} className="animate-spin mx-auto" /></div>
        ) : (
          <>
            <div className="flex items-center gap-3 mb-4">
              <div className={`w-14 h-14 rounded-full bg-gradient-to-br ${avatarGradient(u.display_name)} flex items-center justify-center text-lg font-semibold text-white`}>
                {initials(u.display_name)}
              </div>
              <div className="min-w-0">
                <div className="text-[15px] font-semibold text-gray-900 truncate">{u.display_name}</div>
                <div className="text-[12px] text-gray-400 truncate">@{u.canias_username}</div>
              </div>
            </div>

            <div className="bg-white rounded-xl border border-gray-100 divide-y divide-gray-50">
              <Row icon={Mail} label="E-posta" value={u.email} link={u.email ? `mailto:${u.email}` : null} />
              <Row icon={Building2} label="Departman" value={u.department_name} />
              <Row icon={Briefcase} label="Görev" value={u.work_title_name} />
              <Row icon={Shield} label="Rol" value={u.role_name || u.role_code} />
              <Row icon={Clock} label="Son giriş" value={u.last_login ? formatDateTime(u.last_login) : '—'} />
            </div>

            <button onClick={() => onStartDm?.(u.user_id)}
              className="mt-4 w-full py-2 text-sm font-medium text-white bg-violet-600 hover:bg-violet-700 rounded-lg flex items-center justify-center gap-1.5">
              <MessageSquare size={14} /> Mesaj gönder
            </button>
          </>
        )}
      </div>
    </div>
  )
}

function Row({ icon: Icon, label, value, link }) {
  return (
    <div className="flex items-center gap-2 px-3 py-2">
      <Icon size={13} className="text-gray-400 shrink-0" />
      <span className="text-[11px] text-gray-400 w-20 shrink-0">{label}</span>
      {link ? (
        <a href={link} className="text-[13px] text-violet-600 hover:underline truncate">{value || '—'}</a>
      ) : (
        <span className="text-[13px] text-gray-800 truncate">{value || '—'}</span>
      )}
    </div>
  )
}
